


























































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { HTTP } from '@/plugins/axios'
import dialogViewVentaTaquilla from '@/components/dialogViewVentaTaquilla.vue'
import { TaquillaDTO } from '@/interfaces/Evento.interface'
import { TextMSGDTO } from '@/interfaces/DialogNewRolUsuario.interface'
import DialogNewEvento from '@/components/dialogNewEvento.vue'
import PrintCorte from '@/components/PrintCorte.vue'
import PrintResumenBoleto from '@/components/PrintResumenBoleto.vue'
import PrintResumenVenta from '@/components/PrintResumenVenta.vue'
import PrintResumenCortesCaja from '@/components/PrintResumenCortesCaja.vue'
import moment from 'moment'
import { VentaDTO } from '@/interfaces/Ventas.interface'
import { BoletoVendidoDTO } from '@/interfaces/Boleto.interface'
moment.locale('es-MX')

@Component({
  components: {
    dialogViewVentaTaquilla,
    DialogNewEvento,
    PrintCorte,
    PrintResumenBoleto,
    PrintResumenCortesCaja,
    PrintResumenVenta
  }
})
export default class ViewReportesTaquilla extends Vue {
  private name: string = 'ViewReportesTaquilla'
  private taquillasTable: TaquillaDTO[] = []
  private vendidosTable: BoletoVendidoDTO[] = []
  private corteCajaTable: any[] = []
  private tab: number = 1
  private textMSG: TextMSGDTO = {
    success: {
      text: 'Nuevo Corte de Caja',
      color: 'success'
    },
    delete: {
      text: 'Nuevo Evento:',
      color: 'success'
    },
    callTaquilla: {
      text: 'Modificado Evento:',
      color: 'info'
    },
    fail: {
      text: 'Error al guardar.',
      color: 'error'
    },
  }
  private isOnlyRead: boolean = this.$store.state.auth.user.rol.isOnlyRead

  private ventaTaquillaSelected: string = null
  private resumenBoletosTaquillaSelected: string = null
  private resumenVentaTaquillaSelected: string = null
  private resumenPrintVentasLoading: boolean = false
  private loadingTab1: boolean = false
  private loadingTab3: boolean = false
  private loadingTab4: boolean = false
  private Config: any = {
    pettycashCloseCash: 0.00,
    pettycashMinCash: 0.00,
    pettycashDenom20: 0,
    pettycashDenom50: 0,
    pettycashDenom100: 0,
    pettycashDenom200: 0,
    pettycashDenom500: 0,
    pettycashDenom1000: 0,
    pettycashDenom050: 0,
    pettycashDenom1: 0,
    pettycashDenom2: 0,
    pettycashDenom5: 0,
    pettycashDenom10: 0
  }

  private headersVentas: any[] = [
    {
      text: 'Fecha',
      align: 'left',
      sortable: true,
      value: 'createdAt'
    },
    { text: 'Taquilla', value: 'taquilla.name' },
    { text: 'Transacción', value: 'transaccionID' },
    { text: 'Boletos', value: 'boleto' },
    { text: 'Metodo de Pago', value: 'paymentMethod' },
    { text: 'Monto', value: 'amountPay' },
    { text: 'Acciones', value: 'acciones' }
  ]

  private ventaMetodoPagoSelected: string = null
  private metodoPagoSelected: string = ''
  private metodoPago: any[] = [
    {
      text: 'Todos',
      id: null
    },
    {
      text: 'Tarjeta Credito/Debito',
      id: 'card'
    },
    {
      text: 'Efectivo',
      id: 'cash'
    }
  ]

  private tableVenta: any[] = []
  private menu1: boolean = false
  private menuVentas: boolean = false
  private resumenVentasFechaBusqueda: any = null
  private ventaFechaBusqueda: any = null
  private resumenBoletosFechaBusqueda: any = null
  private optionTaquilla: any[] = []
  private optionTaquillaBase: any = {
    text: 'Todos',
    value: null
  }

  private tipoCorte: any[] = [
    {
      text: 'Exitoso',
      value: true
    },
    {
      text: 'Con Errores',
      value: false
    }
  ]
  private header: any[] = [
    {
      text: 'Fecha',
      align: 'left',
      sortable: true,
      value: 'fecha'
    },
    { text: 'Usuario', value: 'user.name' },
    { text: 'Taquilla', value: 'taquilla.name' },
    { text: 'Ventas', value: 'ventas' },
    { text: 'Boletos', value: 'boletos' },
    { text: 'Monto', value: 'monto' },
    { text: 'Acciones', value: 'acciones' }
  ]
  private headerBoletosResumen: any[] = [
    {
      text: 'Fecha',
      align: 'left',
      sortable: true,
      value: 'fecha'
    },
    { text: 'Folio', value: 'folio' },
    { text: 'Cajera', value: 'taquilla.user.name' },
    { text: 'Monto', value: 'cost' },
    { text: 'Metodo Pago', value: 'metodo' },
    { text: 'Status', value: 'status' },
    { text: 'Info', value: 'acciones' }
  ]
  private headerVentas: any[] = [
    { text: 'Transaccion', value: 'transaccionID' },
    { text: 'Boletos', value: 'boletos' },
    { text: 'Monto', value: 'amountPay' },
    { text: 'Metodo', value: 'paymentMethod' },
    { text: 'Acciones', value: 'acciones' }
  ]
  private headerBoletos: any[] = [
    { text: 'Cantidad', value: 'cantidad' },
    { text: 'Nombre', value: 'name' },
    { text: 'Precio', value: 'monto' },
    { text: 'Total', value: 'total' },
  ]

  private infoToPrint: any = null
  private infoToPrintResumenBoletos: any[] = null
  private infoToPrintResumenVentas: any[] = null
  private infoToPrintResumenCorteCaja: any[] = null
  private downloadPDFLoading: boolean = false

  private corteCajaResumenInfo: any[] = []
  private vendidosResumenInfoBase: any[] = []
  private vendidosResumenInfo: any[] = []
  private actualCorteCaja: any = null
  private showCardInput: boolean = false
  private showCashInput: boolean = false
  private showVentasInput: boolean = false
  private showInfoInput: boolean = true
  private showResumenInput: boolean = false

  private infoVenta: VentaDTO = null

  private catBoleto: any[] = []
  private json_fields_corte: any = null
  private json_fields_boletos: any = null
  private json_fields_ventas: any = null
  private json_data_boletos: any[] = []
  private json_data_corte: any[] = []
  private json_data_ventas: any[] = []

  private corteCajaTableFilter: any[] = []
  private ventasTableFilter: any[] = []

  private json_meta: any[] = [
    {
      key: 'charset',
      value: 'utf-8'
    }
  ]

  private get onlyCardReference () {
    let res: any[] = []
    this.actualCorteCaja.venta.forEach((v: any) => {
      if (v.paymentMethod === 'card') {
        res.push(v)
      }
    })
    return res
  }

  @Watch('tab')
  private watchTab (v: number) {
    console.log('watchTab :: ', v)
    if (v === 1) {
      this.loadingTab1 = true
      this.findTaquillas()
      this.gCorteCaja()
    } else if (v === 3) {
      this.loadingTab3 = true
      this.findAllVendidos()
      this.gCatBoletos()
      this.json_fields_boletos = this.createJsonFieldBoletos()
    } else if (v === 4) {
      this.loadingTab4 = true
      this.gShowAllVentas()
      this.json_fields_ventas = this.createJsonFieldVentas()
    }
  }

  @Watch('resumenBoletosFechaBusqueda')
  private watchResumenBoletosFechaBusqueda (v: boolean) {
    console.log('watchResumenBoletosFechaBusqueda :: ', v)
    this.vendidosResumenInfo = this.tResumenBoletosVendidos(this.vendidosResumenInfoBase)
  }

  @Watch('resumenBoletosTaquillaSelected')
  private watchResumenBoletosTaquillaSelected (v: boolean) {
    console.log('watchResumenBoletosTaquillaSelected :: ', v)
    this.vendidosResumenInfo = this.tResumenBoletosVendidos(this.vendidosResumenInfoBase)
  }

  @Watch('ventaFechaBusqueda')
  private watchVentaFechaBusqueda (v: any) {
    console.log('watchVentaFechaBusqueda :: ', v)
    this.corteCajaTableFilter = this.tCortesCaja(this.corteCajaTable)
  }

  @Watch('ventaTaquillaSelected')
  private watchVentaTaquillaSelected (v: any) {
    console.log('watchVentaTaquillaSelected :: ', v)
    this.corteCajaTableFilter = this.tCortesCaja(this.corteCajaTable)
  }

  @Watch('resumenVentasFechaBusqueda')
  private watchResumenVentasFechaBusqueda (v: any) {
    console.log('watchVentaTaquillaSelected :: ', v)
    this.ventasTableFilter = this.tVentas(this.tableVenta)
  }

  @Watch('ventaMetodoPagoSelected')
  private watchVentaMetodoPagoSelected (v: any) {
    console.log('watchVentaTaquillaSelected :: ', v)
    this.ventasTableFilter = this.tVentas(this.tableVenta)
  }

  @Watch('resumenVentaTaquillaSelected')
  private watchResumenVentaTaquillaSelected (v: any) {
    console.log('watchVentaTaquillaSelected :: ', v)
    this.ventasTableFilter = this.tVentas(this.tableVenta)
  }

  private beforeMount () {
    console.log('beforeMount :: ', this.name)
    this.gShowAllTaquillas()
    this.findTaquillas()
    this.gCorteCaja()
    this.json_fields_ventas = this.createJsonFieldVentas()
  }

  private get cantidadCajaCard () {
    let res: number = 0
    this.actualCorteCaja.venta.forEach((v: VentaDTO) => {
      if (v.paymentMethod === 'card') {
        // @ts-ignore: Unreachable code error
        res = res + parseFloat(v.amountCorteCaja.toString())
      }
    })

    return res
  }

  private tVentas (items: any[]) {
    console.log('tVentas :: ')
    let res: any[] = []
    if (
      (this.ventaMetodoPagoSelected === null) &&
      (this.resumenVentaTaquillaSelected === null) &&
      (this.resumenVentasFechaBusqueda === null)
    ) {
      res = items
    } else {
      let buscaMetodoPago: any = null
      let buscaFecha: any = null
      let buscaTaquilla: any = null
      let buscaTransaccion: any = null

      let found: boolean = false

      console.log('boletoMetodoPagoSelected :: ', this.ventaMetodoPagoSelected)
      console.log('buscaTaquilla :: ', this.resumenVentaTaquillaSelected)
      console.log('buscaFecha :: ', this.resumenVentasFechaBusqueda)

      items.forEach((venta: any) => {
        this.ventaMetodoPagoSelected !== null ? buscaMetodoPago = this.ventaMetodoPagoSelected.toString() : buscaMetodoPago = null
        this.resumenVentaTaquillaSelected !== null ? buscaTaquilla = this.resumenVentaTaquillaSelected.toString() : buscaTaquilla = null
        this.resumenVentasFechaBusqueda !== null ? buscaFecha = this.resumenVentasFechaBusqueda : buscaFecha = null

        if (buscaMetodoPago === null) buscaMetodoPago = venta.paymentMethod
        if (buscaTaquilla === null)   buscaTaquilla = venta.taquilla.id.toString()
        if (buscaFecha === null)      buscaFecha = venta.createdAT

        if (
          (venta.paymentMethod === buscaMetodoPago) &&
          (buscaTaquilla === venta.taquilla.id.toString()) &&
          (moment(buscaFecha).format('YYYY-MM-DD') === moment(venta.createdAt).format('YYYY-MM-DD'))
        ) {
          res.push(venta)
        }

        found = false
      })
    }
    console.log('res :: ', res)

    if (this.json_fields_ventas === null) {
      return res
    }

    let count = 0
    this.json_data_ventas = []
    res.forEach((venta: any) => {
      count++
      let data: any = {}
      for (let [key, val] of Object.entries(this.json_fields_ventas)) {
        // cad +=`${key}: ${val}
        /*
        res['CASH'] = 'montoCASH'
    res['Cancelado CASH'] = 'montoCancelCASH'
    res['CARD'] = 'montoCARD'
    res['Cancelado CARD'] = 'montoCancelCARD'
         */
        if (val === 'fecha') {
          data[val] = moment(venta.createdAt).format('DD/MM/YYYY HH:mm:ss')
        } else if (val === 'taquilla') {
          data[val] = venta.taquilla.name
        } else if (val === 'cajera') {
          data[val] = venta.taquilla.user.name
        } else if (val === 'transaccion') {
          data[val] = venta.transaccionID
        } else if (val === 'montoCASH') {
          data[val] = ''
          if ((venta.paymentMethod === 'cash') && (venta.isCancel === null)) {
            data[val] = venta.amountPay
          }
        } else if (val === 'montoCancelCASH') {
          data[val] = ''
          if ((venta.paymentMethod === 'cash') && (venta.isCancel !== null)) {
            data[val] = venta.amountPay
          }
        } else if (val === 'montoCARD') {
          data[val] = ''
          if ((venta.paymentMethod === 'card') && (venta.isCancel === null)) {
            data[val] = venta.amountPay
          }
        } else if (val === 'montoCancelCARD') {
          data[val] = ''
          if ((venta.paymentMethod === 'card') && (venta.isCancel !== null)) {
            data[val] = venta.amountPay
          }
        } else if (val === 'monto') {
          data[val] = venta.amountPay
        } else if (val === 'metodo') {
          data[val] = venta.paymentMethod.toUpperCase()
        } else if (val === 'status') {
          data[val] = ''
          if (venta.isCancel !== null) {
            data[val] = 'CANCELADO'
          }
        } else if (val === 'corte') {
          data[val] = ''
          if (venta.cortecaja !== null) {
            data[val] = 'SI'
          }
        }
      }
      this.json_data_ventas.push(data)
    })
    return res
  }

  private tCortesCaja (itemsCorteCaja: any[]) {
    console.log('tCortesCaja :: ')
    let res: any[] = []
    if (
      (this.ventaFechaBusqueda === null) &&
      (this.ventaTaquillaSelected === null)
    ) {
      res = itemsCorteCaja
    } else {
      let buscaFecha: any = null
      let buscaTaquilla: any = null

      let found: boolean = false

      console.log('buscaTaquilla :: ', this.ventaTaquillaSelected)
      console.log('buscaFecha :: ', this.ventaFechaBusqueda)

      itemsCorteCaja.forEach((venta: any) => {
        this.ventaTaquillaSelected !== null ? buscaTaquilla = this.ventaTaquillaSelected.toString() : buscaTaquilla = null
        this.ventaFechaBusqueda !== null ? buscaFecha = this.ventaFechaBusqueda : buscaFecha = null

        if (buscaTaquilla === null) buscaTaquilla = venta.taquilla.id.toString()
        if (buscaFecha === null)    buscaFecha = venta.createdAt

        console.log('found :: ', found)

        if (
          (buscaTaquilla === venta.taquilla.id.toString()) &&
          (moment(buscaFecha).format('YYYY-MM-DD') === moment(venta.createdAt).format('YYYY-MM-DD'))
        ) {
          res.push(venta)
        }

        found = false
      })
    }
    console.log('res :: ', res)
    console.log('res :: ', this.json_fields_corte)

    if (this.json_fields_corte === null) {
      return res
    }

    let count = 0
    this.json_data_corte = []
    res.forEach((corte: any) => {
      count++
      let data: any = {}
      for (let [key, val] of Object.entries(this.json_fields_corte)) {
        // cad +=`${key}: ${val}`;
        if (val === 'corte') {
          data[val] = count
        } else if (val === 'fecha') {
          data[val] = moment(corte.createdAt).format('DD/MM/YYYY HH:mm:ss')
        } else if (val === 'taquilla') {
          data[val] = corte.taquilla.name
        } else if (val === 'efectivo') {
          data[val] = corte.cashOnSiteCashUser
        } else if (val === 'banco') {
          data[val] = corte.cashOnSiteCardUser
        } else if (val === 'total') {
          data[val] = corte.cashOnSiteUser
        } else if (val === 'caja') {
          data[val] = corte.minCashBox
        } else if (val === 'totalCaja') {
          // @ts-ignore: Unreachable code error
          data[val] = parseFloat(parseFloat(corte.cashOnSiteUser.toString()) + parseFloat(corte.minCashBox.toString())).toFixed(2)
        } else if (val === 'taquillera') {
          data[val] = corte.taquilla.user.name
        } else if (val === 'totalBoletos') {
          if (corte.boleto !== null) {
            data[val] = corte.boleto.length
          } else {
            // @ts-ignore: Unreachable code error
            data[val] = 0
          }
        } else {
          let boletos: number = 0
          corte.boleto.forEach((bole: any) => {
            if (val === bole.name) {
              boletos++
            }
          })
          // @ts-ignore: Unreachable code error
          data[val] = boletos
        }
      }
      this.json_data_corte.push(data)
    })

    return res
  }

  private showInfoVenta (item: any) {
    console.log('showInfoVenta :: ', item)
    this.infoVenta = Object.assign({}, item)
  }

  private gShowAllVentas () {
    console.log('gShowAllVentas :: ')
    HTTP.get('respaldo/reportes/venta/')
      .then((response) => {
        console.log('gShowAllVentas :: response :: ', response.data)
        this.tableVenta = response.data
        this.ventasTableFilter = this.tVentas(this.tableVenta)
      })
      .catch((e) => {
        console.log('gShowAllRol :: catch :: ', e.response.data)
      })
      .finally(() => {
        console.log('gShowAllVentas :: finally :: ')
        this.loadingTab4 = false
      })
  }

  private createJsonFieldVentas () {
    let res: any = {}
    res['Fecha'] = 'fecha'
    res['Taquilla'] = 'taquilla'
    res['Cajera'] = 'cajera'
    res['Transaccion'] = 'transaccion'
    res['CASH'] = 'montoCASH'
    res['Cancelado CASH'] = 'montoCancelCASH'
    res['CARD'] = 'montoCARD'
    res['Cancelado CARD'] = 'montoCancelCARD'
    res['Monto'] = 'monto'
    res['Metodo de Pago'] = 'metodo'
    res['Status'] = 'status'
    res['Corte'] = 'corte'
    return res
  }

  private createJsonFieldBoletos () {
    let res: any = {}
    res['Fecha'] = 'fecha'
    res['Taquilla'] = 'taquilla'
    res['Cajera'] = 'cajera'
    res['Tipo Boleto'] = 'tipo'
    res['Folio'] = 'folio'
    res['Monto'] = 'monto'
    res['Metodo de Pago'] = 'metodo'
    res['Status'] = 'status'
    return res
  }

  private createJsonField () {
    console.log('json_fields :: ')
    let res: any = {}
    res['# Corte'] = 'corte'
    res['Fecha'] = 'fecha'
    res['Taquilla'] = 'taquilla'
    res['Cajera'] = 'taquillera'

    this.catBoleto.forEach((bole: any) => {
      console.log('bole.name :: ', bole.name)
      res[bole.name] = bole.name
    })

    res['Total Boletos'] = 'totalBoletos'
    res['Efectivo'] = 'efectivo'
    res['Bancos'] = 'banco'
    res['Total'] = 'total'
    res['Caja Chica'] = 'caja'
    res['Total Con Caja'] = 'totalCaja'
    console.log('json_fields :: res:: ', res)
    return res
  }

  private soloEfectivoCancelado (ventas: VentaDTO[]) {
    console.log('soloEfectivoCancelado :: ', ventas)
    let res: number = 0
    ventas.forEach((vent: VentaDTO) => {
      if (vent.isCancel !== null && vent.paymentMethod === 'cash') {
        res = res + parseFloat(vent.amountPay.toString())
      }
    })
    return res.toFixed(2)
  }

  private soloTarjetaCancelado (ventas: VentaDTO[]) {
    console.log('soloTarjetaCancelado :: ', ventas)
    let res: number = 0
    ventas.forEach((vent: VentaDTO) => {
      if (vent.isCancel !== null && vent.paymentMethod === 'card') {
        res = res + parseFloat(vent.amountPay.toString())
      }
    })
    return res.toFixed(2)
  }

  private cantidadTotal (ventas: VentaDTO[]) {
    console.log('cantidadTotal :: ', ventas)
    let res: number = 0

    ventas.forEach((vent: VentaDTO) => {
      if (vent.isCancel === null) {
        res = res + parseFloat(vent.amountPay.toString())
      }
    })

    res = res + parseFloat(this.actualCorteCaja.minCashBox)
    return res.toFixed(2)
  }

  private soloEfectivo (ventas: VentaDTO[]) {
    console.log('soloEfectivo :: ', ventas)
    let res: number = 0
    ventas.forEach((vent: VentaDTO) => {
      if (vent.isCancel === null && vent.paymentMethod === 'cash') {
        res = res + parseFloat(vent.amountPay.toString())
      }
    })
    return res.toFixed(2)
  }

  private soloTarjeta (ventas: VentaDTO[]) {
    console.log('soloTarjeta :: ', ventas)
    let res: number = 0
    ventas.forEach((vent: VentaDTO) => {
      if (vent.isCancel === null && vent.paymentMethod === 'card') {
        res = res + parseFloat(vent.amountPay.toString())
      }
    })
    return res.toFixed(2)
  }

  private viewCorteCaja (item: any) {
    console.log('viewCorteCaja :: ', item)
    this.actualCorteCaja = Object.assign({}, item)
    this.corteCajaResumenInfo = this.totalResumenBoletos()
    this.tab = 2
  }

  private findTaquillas () {
    console.log('findTaquillas :: ')
    HTTP.get('respaldo/reportes/taquilla-working')
      .then((response) => {
        console.log('findTaquillas :: response :: ', response.data)
        this.taquillasTable = response.data
      })
      .catch((e) => {
        console.log('findTaquillas :: catch :: ', e.response.data)
      })
  }

  private findAllVendidos () {
    console.log('findAllVendidos :: ')
    HTTP.get('respaldo/reportes/vendido/')
      .then((response) => {
        console.log('findAllVendidos :: response :: ', response.data)
        this.vendidosTable = response.data
        this.vendidosResumenInfo = this.totalResumenBoletosVendidos(this.vendidosTable)
        this.vendidosResumenInfoBase = this.vendidosResumenInfo
        this.vendidosResumenInfo = this.tResumenBoletosVendidos(this.vendidosResumenInfoBase)
      })
      .catch((e) => {
        console.log('findAllVendidos :: catch :: ', e.response.data)
      })
      .finally(() => {
        console.log('gShowAllVentas :: finally :: ')
        this.loadingTab3 = false
      })
  }

  private totalResumenBoletosVendidos (vendidos: any) {
    console.log('totalResumenBoletosVendidos :: 1')
    let categorias: any[] = []
    vendidos.forEach(async (bole: any) => {
      let catFount = false
      categorias.forEach((cate: any) => {
        if (bole.name === cate.name) {
          catFount = true
        }
      })

      if (!catFount) {
        categorias.push({name: bole.name, order: bole.boleto.order, total: 0, monto: 0, cantidad: 0, openTab: false, boletos: [] })
      }
    })

    console.log('categorias :: ', categorias)

    vendidos.forEach((bole: any) => {
      categorias.forEach((cate: any) => {
        if (bole.name === cate.name) {
          cate.cantidad = parseInt(cate.cantidad, 10) + 1
          cate.total = parseFloat(cate.total.toString()) + parseFloat(bole.cost.toString())
          cate.monto = bole.cost
          cate.total = cate.total.toFixed(2)
          cate.boletos.push(bole)
        }
      })
    })

    console.log('categorias :: ', categorias)
    return categorias
  }

  private excelResumeBoletos (items: any[]) {
    console.log('excelResumeBoletos :: ', items)
    this.json_data_boletos = []
    items.forEach((categoria: any) => {
      categoria.boletos.forEach((boletos: any) => {
        let data: any = {}
        for (let [key, val] of Object.entries(this.json_fields_boletos)) {
          // console.log('val :: ', val)
          if (val === 'fecha') {
            data[val] = moment(boletos.createdAt).format('DD/MM/YYYY HH:mm:ss')
          } else if (val === 'folio') {
            const folio = boletos.folio.toString()
            const nFolio = '\'' + folio.substr(0, folio.length)
            data[val] = nFolio
          } else if (val === 'tipo') {
            data[val] = boletos.name
          } else if (val === 'monto') {
            data[val] = parseFloat(boletos.cost).toFixed(2)
          } else if (val === 'metodo') {
            if (boletos.venta !== null) {
              data[val] = boletos.venta.paymentMethod.toUpperCase()
            } else {
              data[val] = 'ERROR-NO-VENTA'
            }
          }  else if (val === 'taquilla') {
            data[val] = boletos.taquilla.name
          }  else if (val === 'cajera') {
            data[val] = boletos.taquilla.user.name
          } else if (val === 'status') {
            if (boletos.venta !== null) {
              if (boletos.venta.isCancel !== null) {
                data[val] = 'CANCELADO'
              } else {
                data[val] = ''
              }
            } else {
              data[val] = 'ERROR-NO-VENTA'
            }
          }
        }

        this.json_data_boletos.push(data)
      })
    })
  }

  private tResumenBoletosVendidos (categorias: any[]) {
    console.log('tResumenBoletosVendidos :: ', categorias)
    let res: any[] = []
    if (
      (this.resumenBoletosFechaBusqueda === null) &&
      (this.resumenBoletosTaquillaSelected === null)
    ) {
      res = this.vendidosResumenInfo
    } else {
      let buscaFecha: any = null
      let buscaTaquilla: any = null

      let found: boolean = false

      console.log('buscaTaquilla :: ', this.resumenBoletosTaquillaSelected)
      console.log('buscaFecha :: ', this.resumenBoletosFechaBusqueda)

      categorias.forEach((categoria: any, indexCat: any) => {
        res.push({name: categoria.name, total: 0, monto: 0, cantidad: 0, openTab: false, boletos: [] })
        categoria.boletos.forEach((boletos: any, indexBole: any) => {
          this.resumenBoletosTaquillaSelected !== null ? buscaTaquilla = this.resumenBoletosTaquillaSelected.toString() : buscaTaquilla = null
          this.resumenBoletosFechaBusqueda !== null ? buscaFecha = this.resumenBoletosFechaBusqueda : buscaFecha = null

          if (buscaTaquilla === null) buscaTaquilla = boletos.taquilla.id.toString()
          if (buscaFecha === null)    buscaFecha = boletos.createdAt

          console.log('found :: ', found)

          if (
            (buscaTaquilla === boletos.taquilla.id.toString()) &&
            (moment(buscaFecha).format('YYYY-MM-DD') === moment(boletos.createdAt).format('YYYY-MM-DD'))
          ) {
            res[indexCat].cantidad = parseInt(res[indexCat].cantidad, 10) + 1
            res[indexCat].total = parseFloat(res[indexCat].total.toString()) + parseFloat(boletos.cost.toString())
            res[indexCat].monto = boletos.cost
            res[indexCat].total = res[indexCat].total.toFixed(2)
            res[indexCat].boletos.push(boletos)
          }

          found = false
        })
      })
    }

    this.excelResumeBoletos(res)

    console.log('res :: ', res)
    return res
  }

  private totalResumenBoletos () {
    console.log('totalResumenBoletos :: 1')
    let categorias: any[] = []
    this.actualCorteCaja.boleto.forEach(async (bole: any) => {
      let catFount = false
      categorias.forEach((cate: any) => {
        if (bole.name === cate.name) {
          catFount = true
        }
      })

      if (!catFount) {
        categorias.push({ name: bole.name, total: 0, monto: 0, cantidad: 0, openTab: false, boletos: [] })
      }
    })

    console.log('categorias :: ', categorias)
    this.actualCorteCaja.boleto.forEach((bole: any) => {
      categorias.forEach((cate: any) => {
        if (bole.name === cate.name) {
          cate.cantidad = parseInt(cate.cantidad, 10) + 1
          cate.total = parseFloat(cate.total.toString()) + parseFloat(bole.cost.toString())
          cate.monto = bole.cost
          cate.total = cate.total.toFixed(2)
          cate.boletos.push(bole)
        }
      })
    })

    console.log('categorias :: ', categorias)
    return categorias
  }

  private gCorteCaja () {
    console.log('gCorteCaja :: ')
    this.loadingTab1 = true
    HTTP.get('respaldo/reportes/corte-caja/')
      .then((response) => {
        console.log('gCorteCaja :: response :: ', response.data)
        this.corteCajaTable = response.data
        this.corteCajaTableFilter = this.tCortesCaja(this.corteCajaTable)
        this.loadingTab1 = false
      })
      .catch((e) => {
        console.log('gCorteCaja :: catch :: ', e.response.data)
      })
  }

  private gShowAllTaquillas () {
    console.log('findTaquilla :: ')
    HTTP.get('respaldo/reportes/taquilla/')
      .then((response) => {
        console.log('findTaquilla :: response :: ', response.data)
        const taquillaTable = response.data
        this.optionTaquilla = []
        this.optionTaquilla.push(this.optionTaquillaBase)
        taquillaTable.forEach((taquilla: any) => {
          // console.log('bole:: bole :: ', taquilla)
          this.optionTaquilla.push({
            text: taquilla.user.name + ' (' + taquilla.name + ')',
            value: taquilla.id
          })
        })
      })
      .catch((e) => {
        console.log('findTaquilla :: catch :: ', e.response.data)
      })
  }

  private printCorteNow (item: any) {
    console.log('printCorteNow :: ', item)
    this.infoToPrint = Object.assign({}, item)
  }

  private printResumeBoletosNow (item: any[]) {
    console.log('printResumeBoletosNow :: ', item)
    let taquillaName: string = 'Todos'
    this.optionTaquilla.forEach((option: any) => {
      console.log('option :: ', option)
      if (option.value === this.resumenBoletosTaquillaSelected) {
        taquillaName = option.text
      }
    })
    const infoPrint: any = {
      info: {
        fecha: this.resumenBoletosFechaBusqueda,
        cajera: taquillaName
      },
      items: item
    }

    console.log('infoPrint :: ', infoPrint)
    this.infoToPrintResumenBoletos = Object.assign({}, infoPrint)
  }

  private printResumeVentasNow (item: any[]) {
    console.log('printResumeVentasNow :: ', item)
    let taquillaName: string = 'Todos'
    let metodoPago: string = 'Todos'
    this.optionTaquilla.forEach((option: any) => {
      console.log('option :: ', option)
      if (option.value === this.resumenVentaTaquillaSelected) {
        taquillaName = option.text
      }
    })
    if (this.ventaMetodoPagoSelected !== null) {
      metodoPago = this.ventaMetodoPagoSelected.toUpperCase()
    }
    const infoPrint: any = {
      info: {
        fecha: this.resumenVentasFechaBusqueda,
        cajera: taquillaName,
        metodo: metodoPago
      },
      items: item
    }

    console.log('infoPrint :: ', infoPrint)
    this.infoToPrintResumenVentas = Object.assign({}, infoPrint)
  }

  private printResumeCortesCajaNow (item: any[]) {
    console.log('printResumeCortesCajaNow :: ', item)
    let taquillaName: string = 'Todos'
    this.optionTaquilla.forEach((option: any) => {
      console.log('option :: ', option)
      if (option.value === this.ventaTaquillaSelected) {
        taquillaName = option.text
      }
    })
    const infoPrint: any = {
      info: {
        fecha: this.ventaFechaBusqueda,
        cajera: taquillaName
      },
      items: item
    }

    console.log('infoPrint :: ', infoPrint)
    this.infoToPrintResumenCorteCaja = Object.assign({}, infoPrint)
  }

  private gCatBoletos () {
    this.loadingTab3 = true
    HTTP.get('respaldo/reportes/boleto/')
      .then((response) => {
        console.log('gCatBoletos :: response :: ', response.data)
        this.catBoleto = response.data
        this.json_fields_corte = this.createJsonField()
        this.loadingTab3 = false
      })
      .catch((e) => {
        console.log('gCatBoletos :: catch :: ', e.response.data)
      })
  }
}
